import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteMosaicWidget(
    $tenantId: ID!
    $zoneId: ID!
    $widgetIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          deleteWidget(identifier: $widgetIdentifier)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.DeleteMosaicWidgetMutation,
  undefined,
  graphql.schema.DeleteMosaicWidgetMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
